import {API_HEADERS, REACT_APP_LIFERAY_HOST, REACT_APP_SCOPE_KEY, VENTE_RELATION} from "./utils";




export default class ServicePrincipal {


    // ✅ Fetch participant by reference
    async searchParticipantByReference(payload) {
        const reference = payload.reference;
        const url = `${REACT_APP_LIFERAY_HOST}/o/c/participantencheres/scopes/${REACT_APP_SCOPE_KEY}?filter=reference eq '${reference}'&nestedFields=${VENTE_RELATION}`;
        // const url = `${REACT_APP_LIFERAY_HOST}/o/c/venteauxencheres/${venteId}`;
        try {
            const response = await fetch(url, {
                method: 'GET',
                headers: API_HEADERS
            });
            if (!response.ok) {
                throw new Error(`Erreur HTTP: ${response.status}`);
            }
            const data = await response.json();
            console.log("🚀 ~ ServicePrincipal ~ fetchVentes ~ data:", data)
            return data;
        } catch (error) {
            console.log("🚀 ~ GestionIdentifiantAffaire ~ fetchTypeBienNature ~ error:", error)
            throw error;
        }
    }

}


